import { useDataValue } from 'Simple/Data.js'

/** @type {import('Simple/types.js').useDataConfiguration} */
export default function useDataConfiguration(props) {
  let patient_id = useDataValue({
    context: 'appointment_overlay',
    path: 'patient_id',
    viewPath: props.viewPath,
  })

  return {
    variables: {
      patient_id,
    },
  }
}
